import { render, staticRenderFns } from "./ClientsManagementEdit.vue?vue&type=template&id=bf694b0e&scoped=true"
import script from "./ClientsManagementEdit.vue?vue&type=script&lang=js"
export * from "./ClientsManagementEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientsManagementEdit.vue?vue&type=style&index=0&id=bf694b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf694b0e",
  null
  
)

export default component.exports